import {CMP, MY_PRICE} from "../../modules/PriceBlock/PriceTypes";
import {GST_INCLUSIVE, GST_EXCLUSIVE} from "../../modules/PriceBlock/GstTypes";

class PriceService {
  constructor(priceServiceClient, templateContext) {
    this._pack1Uom = templateContext.pack1Uom;
    this._pack2Uom = templateContext.pack2Uom;
    this._priceServiceClient = priceServiceClient;
  }

  fetchPrices = async (customerId, postCode, productCodes) => {
    const data = await this._priceServiceClient.fetchPrices(customerId, postCode, productCodes);

    const prices = data && data.prices ? data.prices : [];

    return productCodes.reduce((result, productCode) => {
      const productPrices = prices.find(item => `${item.productCode}` === `${productCode}`);

      result[productCode] = this._transformPriceData(productPrices);

      return result;
    }, {});
  };

  fetchPrice = async (customerId, postCode, productCode) => {
    const response = await this.fetchPrices(customerId, postCode, [productCode]);

    return response[productCode];
  };

  _transformPriceData = (productPrices) => {
    if (!productPrices) {
      return {};
    }

    const { cmp, customerPrices } = productPrices;
    const mapPriceData = {};

    if (cmp) {
      mapPriceData[CMP] = {};
      if (cmp.PACK1) {
        mapPriceData[CMP][this._pack1Uom] = {};
        mapPriceData[CMP][this._pack1Uom][GST_INCLUSIVE] = cmp.PACK1.gstInclusive;
        mapPriceData[CMP][this._pack1Uom][GST_EXCLUSIVE] = cmp.PACK1.gstExclusive;
      }
      if (cmp.PACK2) {
        mapPriceData[CMP][this._pack2Uom] = {};
        mapPriceData[CMP][this._pack2Uom][GST_INCLUSIVE] = cmp.PACK2.gstInclusive;
        mapPriceData[CMP][this._pack2Uom][GST_EXCLUSIVE] = cmp.PACK2.gstExclusive;
      }
    }

    if (customerPrices) {
      mapPriceData[MY_PRICE] = {};
      if (customerPrices.PACK1) {
        mapPriceData[MY_PRICE][this._pack1Uom] = {};
        mapPriceData[MY_PRICE][this._pack1Uom][GST_INCLUSIVE] = customerPrices.PACK1.gstInclusive;
        mapPriceData[MY_PRICE][this._pack1Uom][GST_EXCLUSIVE] = customerPrices.PACK1.gstExclusive;
      }
      if (customerPrices.PACK2) {
        mapPriceData[MY_PRICE][this._pack2Uom] = {};
        mapPriceData[MY_PRICE][this._pack2Uom][GST_INCLUSIVE] = customerPrices.PACK2.gstInclusive;
        mapPriceData[MY_PRICE][this._pack2Uom][GST_EXCLUSIVE] = customerPrices.PACK2.gstExclusive;
      }
    }

    return mapPriceData;
  };
}

export default PriceService;
